import cx from 'classnames'
import { ReactNode, CSSProperties } from 'react'
import { IIconColor } from '@/models'

interface IIconProps extends IIconColor {
  children?: ReactNode
  mui?: boolean
  name?: string
  className?: string
  style?: CSSProperties
  size?: 'xxl' | 'xl' | 'lg' | 'md' | 'sm' | 'xs' | 'xxs'
  title?: string
  hoverColor?: 'gray'
  onClick?: (data?: any) => void
  onBlur?: () => void
  disable?: boolean
}

function Icon({
  children,
  mui,
  name,
  className,
  style,
  size,
  color = 'primary',
  title,
  hoverColor,
  onClick,
  onBlur,
  disable = false,
  ...props
}: IIconProps) {
  const classNames = cx(
    'icon',
    {
      'material-icons': mui,
      [`icon-${name}`]: !mui && name,
      [`size-${size}`]: size,
      [`color-${color}`]: color,
      [`hover-${hoverColor}`]: hoverColor
    },
    className
  )

  if (!name && !mui) return null

  return (
    <i
      className={classNames}
      style={style}
      title={title}
      onClick={!disable ? onClick : () => {}}
      onBlur={!disable ? onBlur : () => {}}
      {...props}
    >
      {mui && (children || name)}
    </i>
  )
}

export default Icon
